import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { attendanceData } from '../../../Constant/charts';
import { useTranslation } from 'react-i18next';

const AttendanceChart = ({ title, filter }) => {
  const { t } = useTranslation();

  // Filter data based on selected filter
  const filteredData = attendanceData.map(item => {
    if (filter === 'all') {
      return {
        ...item,
        name: t(item.name)
      };
    } else {
      return { 
        name: t(item.name),
        [filter]: item[filter]
      };
    }
  });

  return (
    <div className="bg-white shadow-md p-4 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">{ t(title) }</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={filteredData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {filter === 'all' || filter === 'teachersAttendance' ? <Bar dataKey="teachersAttendance" name={t('TeacherAttendance')} fill="#8884d8" /> : null}
          {filter === 'all' || filter === 'learnersAttendance' ? <Bar dataKey="learnersAttendance" name={t('StudentAttendance')} fill="#82ca9d" /> : null}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AttendanceChart;
